import { render, staticRenderFns } from "./fireDetectionAlarmSystemDoc.vue?vue&type=template&id=783979f5"
import script from "./fireDetectionAlarmSystemDoc.vue?vue&type=script&lang=js"
export * from "./fireDetectionAlarmSystemDoc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('783979f5')) {
      api.createRecord('783979f5', component.options)
    } else {
      api.reload('783979f5', component.options)
    }
    module.hot.accept("./fireDetectionAlarmSystemDoc.vue?vue&type=template&id=783979f5", function () {
      api.rerender('783979f5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/psi/lbe/fdas/fireDetectionAlarmSystemDoc.vue"
export default component.exports